export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; allowedRoles?: string[] }
  children?: INavigationRoute[]
}

const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'contractor-dashboard',
      displayName: 'Portal Dashboard',
      meta: { icon: 'mso-dashboard', allowedRoles: ['client_portal'] },
    },
    {
      name: 'contractor-live-tracker',
      displayName: 'Fleet Tracker',
      meta: { icon: 'mso-location_on', allowedRoles: ['client_portal'] },
    },
    {
      name: 'contractor-vehicles',
      displayName: 'Assets',
      meta: { icon: 'mso-directions_car', allowedRoles: ['client_portal'] },
    },
    {
      name: 'contractor-drivers',
      displayName: 'Drivers',
      meta: { icon: 'mso-person', allowedRoles: ['client_portal'] },
    },
    {
      name: 'contractor-report',
      displayName: 'Report',
      meta: { icon: 'mso-description', allowedRoles: ['client_portal'] },
      children: [
        {
          name: 'contractor-reports',
          displayName: 'Odometer Report',
          meta: { icon: 'mso-speed', allowedRoles: ['client_portal'] },
        },
        {
          name: 'contractor-charging-dashboard',
          displayName: 'Charging Dashboard',
          meta: { icon: 'mso-ev_station', allowedRoles: ['client_portal'] },
        },
        {
          name: 'contractor-vehicle-activity',
          displayName: 'Vehicle Activity',
          meta: { icon: 'mso-sensors', allowedRoles: ['client_portal'] },
        },
      ],
    },
    {
      name: 'contractor-team',
      displayName: 'Portal Users',
      meta: { icon: 'mso-group', allowedRoles: ['client_portal'] },
    },
    {
      name: 'contractor-preferences',
      displayName: 'Settings',
      meta: { icon: 'mso-settings', allowedRoles: ['client_portal'] },
    },
  ] as INavigationRoute[],
}

export default sidebarRoutes
